import { motion } from 'framer-motion';

const fadeOnceVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.98 },
    visible: { opacity: 1, y: 0, scale: 1 },
};

// This creates a wrapper component that applies the fade-in effect, and it only animates once when it comes into view
export const ScrollFadeIn: React.FC<React.PropsWithChildren> = ({ children }) => (
    <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeOnceVariants}
        transition={{ duration: 0.6, ease: 'easeOut' }}
    >
        {children}
    </motion.div>
);
